import { Inject, Injectable } from "@angular/core";
import { DwContextDefinition, DwCustomContextBase, DwCustomContextDefinition, DwOrmDataService, DwOrmDataServiceToken, DwQuery, DwUserEntity } from "@devwareapps/devware-cap";
import { AcsTestEntity, AppMetaData, AppMetaDataItemNames, CheckRideRequestEntity, FlightSchoolApplicantEntity, PilotExaminerEntity, PlanOfActionEntity, RoPlanOfActionDetailsEntity } from "../../../meta-data/app-meta-data.service";
import { ExaminerRepositoryService } from "../../examiner/services/examiner-repository.service";
import { of } from "rxjs";

@DwCustomContextDefinition({
    keyName: 'planofaction-test-type-context',
    display: 'Plan of Action Test Type Context',
    isGlobal: false,
    parentItem: AppMetaDataItemNames.PlanOfAction,
})
@Injectable()
export class PlanOfActionTestTypeContextService extends DwCustomContextBase {

    constructor(
        @Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService,
        private examinerRepositoryService: ExaminerRepositoryService
    ) {
        super();
    }

    setupContextDefinition(contextDef: DwContextDefinition) {
        contextDef.getCustomContextFunction = (resolvedContext, contextData) => {
            let testTypeId = this.getTestTypeId(resolvedContext);

            if (!testTypeId) {
                return of(null);
            }

            return this.examinerRepositoryService.getCheckrideTestType(testTypeId);
        };

        contextDef.item = AppMetaDataItemNames.CheckRideTestType;
        contextDef.getCustomContextKey = (resolvedContext) => {
            let testTypeId = this.getTestTypeId(resolvedContext);

            return testTypeId;
        };

        contextDef.useItemMetaData = true;
    }

    getTestTypeId(resolvedContext: any) {
        const planOfActionDetails: RoPlanOfActionDetailsEntity = resolvedContext['Plan_Of_Action_Details'];

        return planOfActionDetails?.CheckRideFinalTestTypeId;
    }
} 